export const paginationIntlIds = {
  pagination: {
    loading: 'paginationIntlIds.pagination.loading',
    items: 'paginationIntlIds.pagination.items',
    pages: 'paginationIntlIds.pagination.pages',
  },
};
